import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useGetNamedColor from '../../common/useGetNamedColor';
import DropdownSelector from '../../components/actions/DropdownSelector';
import Tag from '../../helpContext/Tag';
import useActualityAggregationMetricDescriptors from '../hooks/useActualityAggregationMetricDescriptors';
import { ActualityAggregatedHqExtendedStatsDataColumn } from '../store/actuality.kpi.types';

export type ActualityAggregateMetricSelectorProps = {
  title?: string;
  value: ActualityAggregatedHqExtendedStatsDataColumn;
  onChange: (v: ActualityAggregatedHqExtendedStatsDataColumn) => void;
};

const ActualityAggregateMetricSelector: React.FC<
  ActualityAggregateMetricSelectorProps
> = props => {
  const { t } = useTranslation('feed');
  const aggMetricDescriptors = useActualityAggregationMetricDescriptors();
  const getNamedColor = useGetNamedColor();

  return (
    <DropdownSelector
      label={props.title}
      // label={t('Metric')}
      className="w-full text-xs"
      // multiline
      // w_xl
      panelModeMultiline
      value={props.value}
      values={_.map(aggMetricDescriptors, d => d.id)}
      renderValueSelected={id => aggMetricDescriptors[id]?.title ?? id}
      renderValue={(id, filter) => {
        const desc = aggMetricDescriptors[id];
        const title = desc?.title ?? id;
        return (
          <>
            <div>{title}</div>
            <Tag
            // className="text-menu-text group-hover:text-menu-text-hover text-xs"
            // style={{ color: _.head(getNamedColor(desc.category)) }}
            >
              #{desc.category}
            </Tag>
          </>
        );
      }}
      
          panelMode
          w_xl
          DropAlignRight
      onChange={v => setTimeout(() => props.onChange(v), 10)}
      hasSearch
      filterValue={(field, filter) => {
        const descriptor = aggMetricDescriptors[field];
        return (
          _.isEmpty(filter) ||
          _.some(
            [descriptor?.title, descriptor.category],
            t => t.toLowerCase().indexOf(filter.toLowerCase()) >= 0,
          )
        );
      }}
    />
  );
};
export default ActualityAggregateMetricSelector;
